import { type BridgeData } from '@databases/database-state/state/bridge-data';
// eslint-disable-next-line no-restricted-imports
import { getCurrentScope, setUser } from '@sentry/react';

export const configureSentry = ({
  cloudId,
  userId,
}: Pick<BridgeData, 'cloudId' | 'userId'>) => {
  getCurrentScope().setTag('cloudId', cloudId);
  setUser({ id: userId });
};
